import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpParams } from '@angular/common/http';
import { LOCALE_ID, Inject } from '@angular/core';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {
    constructor(@Inject(LOCALE_ID) protected localeId: string, private route: ActivatedRoute, private http: HttpClient, private router: Router, ) {  }
    profileName = '';
    mondiaStatus = '';
    mondiacustID = '';
    usernameLogin = '';
    siteID = environment.siteID;
    passLogin = '';
    mondiaOperator = '';
    operatorID = '';
    redirectURL = '';
    tempPass = 'demoPasswordHere!';
    loaded: boolean = false;
    username = '99999999900';
    isTrue: boolean = false;
    orderObj: any = [];
    hideUsername: boolean = false;
    preferredCountries = [
        { "country": "South Africa", "code": 'za', "dialcode": "+27" },
        { "country": "Nigeria", "code": 'ng', "dialcode": "+97" },
        { "country": "Tunisia", "code": 'tu', "dialcode": "+22" },
        { "country": "Egypt", "code": 'eg', "dialcode": "+20" }
    ];
    autoLogin() {
      
      this.route.params.subscribe(params2 => {
          this.redirectURL = params2['redirect'];
          var currentUser
          var baseUrl = "https://api-staging.videyo.tv"

          this.http.post(baseUrl + '/api/login', {
              'username': this.username,
              'password': this.tempPass
          }).subscribe(
              res => {
                  localStorage.setItem('access_token', (res["access_token"]));
                  if (window.location.pathname.indexOf('\/fr\/') > -1) {
                      this.router.navigate(["/"]);
                  }
                 else if (window.location.pathname.indexOf('\/en\/') > -1) {
                      this.router.navigate(["/"]);
                  }
                  else if (window.location.pathname.indexOf('\/ar\/') > -1) {
                      this.router.navigate(["/"]);
                  } 
                  else {
                    this.router.navigate(["/"]);
                  }


              },
              err => {
                  alert('Password Incorrect, Please try again or reset below');
              }
          );
          return false;
      });
      console.log('New User Login')
  }
  refresh(): void {
    window.location.reload();
}
 

    ngOnInit() {

       
    }
 
}
